import { post } from 'axios';
import { SUPPORT_API_URL } from '../config/constants';

// eslint-disable-next-line import/prefer-default-export
export const submitSupportCase = (payload) => {
  return post(SUPPORT_API_URL, payload).then(
    (response) => response.data,
    (err) => {
      throw new Error(err);
    },
  );
};
